// Route-aware resume target for a saved import (landing page Continue + wizard redirect).
export const closingSnapshotPath = (conversionId) => `/stocktaking/import/closing-snapshot?conversion_id=${conversionId}`;

export const matchingPath = (s1RunId, conversionId) =>
  `/stocktaking/psb-stage1b-mapping?s1_run_id=${s1RunId}${conversionId ? `&conversion_id=${conversionId}` : ''}`;

export const resumePathForImport = (draft) => {
  const wizard = `/stocktaking/import/historical-stocktake?conversion_id=${draft.conversion_id}`;
  if (draft.import_route === 'route_a' && !draft.is_dispatched && draft.stage1_run_id) {
    return draft.stage1_review_count > 0
      ? matchingPath(draft.stage1_run_id, draft.conversion_id)
      : closingSnapshotPath(draft.conversion_id);
  }
  // Full historical (Route B) imports are history: read-only view, never resume the pipeline.
  return wizard;
};

export const isHistoryImport = (draft) => draft.is_dispatched || draft.import_route !== 'route_a';
